import { z } from 'zod';
import { DEFAULT_PROJECT_ICON, DEFAULT_PROJECT_ICON_COLOR, PROJECT_ICON_COLORS, PROJECT_ICONS, PROJECT_STATUSES, } from '../enums.js';
import { projectCodePattern } from '../keys.js';
import { nonEmptyString, optionalText, paginationSchema } from './common.js';
export const projectCodeSchema = z
    .string({ required_error: 'Code is required' })
    .trim()
    .toUpperCase()
    .min(2, 'Code must be at least 2 characters')
    .max(10, 'Code must be at most 10 characters')
    .regex(projectCodePattern, 'Code must be uppercase letters and digits, starting with a letter');
/** Picked from a fixed set; both fall back to the default when left out. */
const iconFields = {
    icon: z.enum(PROJECT_ICONS).default(DEFAULT_PROJECT_ICON),
    iconColor: z.enum(PROJECT_ICON_COLORS).default(DEFAULT_PROJECT_ICON_COLOR),
};
export const createProjectSchema = z.object({
    name: nonEmptyString(120, 'Name'),
    code: projectCodeSchema,
    description: optionalText(2000),
    ...iconFields,
});
export const updateProjectSchema = z
    .object({
    name: nonEmptyString(120, 'Name').optional(),
    description: optionalText(2000),
    status: z.enum(PROJECT_STATUSES).optional(),
    icon: z.enum(PROJECT_ICONS).optional(),
    iconColor: z.enum(PROJECT_ICON_COLORS).optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to update' });
export const listProjectsSchema = paginationSchema.extend({
    status: z.enum(PROJECT_STATUSES).optional(),
    q: z.string().trim().max(200).optional(),
});
//# sourceMappingURL=project.js.map